<template>
  <loading v-model="loading" :height="500">
    <div class="table-fix-head table-height-500">
      <table class="table table-light">
        <thead>
          <th scope="col" class="p-2 pb-2" v-if="!table$hiddenColumns.has('checkbox')">
            <b-form-checkbox v-bind="checkbox$header" @change="checkbox$toggle"/>
          </th>
          <th scope="col" class="p-2 pb-2" v-if="!table$hiddenColumns.has('dispatched_at')">
            Kiküldve
          </th>
          <th scope="col" class="p-2 pb-2" v-if="!table$hiddenColumns.has('account')">
            Fiók
          </th>
          <th scope="col" class="p-2 pb-2" v-if="!table$hiddenColumns.has('name')">
            Kampány
          </th>
          <th scope="col" class="p-2 pb-2 text-right" v-if="!table$hiddenColumns.has('actions')">
            <list-actions :selection="checkbox$selection" :actions="actions" :processing="processing"/>
          </th>
        </thead>

        <tr
          v-for="(campaign, index) in campaigns"
          :key="`tr${index}`"
        >
          <td class="p-2" v-if="!table$hiddenColumns.has('checkbox')">
            <b-form-checkbox
              v-model="checkbox$selection"
              :value="campaign.id"
            />
          </td>
          <td class="p-2" v-if="!table$hiddenColumns.has('dispatched_at')">
            {{ displayFormatDate(campaign.dispatched_at) }}
          </td>
          <td class="p-2" v-if="!table$hiddenColumns.has('account')">
            {{ campaign.account.name }}
          </td>
          <td class="p-2" v-if="!table$hiddenColumns.has('name')">
            {{ campaign.name }}
          </td>
          <td scope="p-2" v-if="!table$hiddenColumns.has('actions')"></td>
        </tr>
      </table>
    </div>
    <div class="text-right mt-3" v-if="!table$hiddenColumns.has('checkbox')">
      {{ checkbox$selection.length }} elem kiválasztva
    </div>
  </loading>
</template>
<script>
import { displayFormatDate } from '../../utils/Date'
import CheckboxHelper from '../../utils/mixins/CheckboxHelper'
import TableHelper from '../../utils/mixins/TableHelper'
import ListActions from '../common/ListActions'
import Loading from '../common/LoadingPlaceholder'

export default {
  mixins: [
    CheckboxHelper('campaigns', 'id', true),
    TableHelper('campaigns', 'id', {
      fromDate: {
        type: String,
        default: ''
      },
      toDate: {
        type: String,
        default: ''
      },
      accountId: {
        type: Number,
        default: -1
      },
    }, 'api.test-campaigns.index')
  ],
  components: {
    'loading': Loading,
    'list-actions': ListActions
  },
  props: {
    processing: {
      type: Boolean,
      required: false,
      default: false
    },
    actions: {
      type: Array,
      required: false,
      default: () => ([])
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    displayFormatDate
  }
}
</script>